// extracted by css-extract-rspack-plugin
var _1 = "panel-YVjvLs";
export { _1 as "panel" }
